import { Checklist } from "../bdm-assessment-interfaces/view-bdmassessment.interface";

export class Bdmassessmentmodels {

    private onboardingid!: number;
    private checklist!: Checklist[];
    private declaration_date!: string;
    private is_completed!: boolean;
    private bdmName!: string;
    private remarkContent!: string;
    private remarkid!: number;
    private updatedbyroleRemark!: string;

    constructor() { }

    // Getters & Setters
    getOnboardingid(): number {
        return this.onboardingid;
    }
    setOnboardingid(onboardingid: number) {
        this.onboardingid = onboardingid;
    }

    getDeclaration_date(): string {
        return this.declaration_date;
    }
    setDeclaration_date(declaration_date: string) {
        this.declaration_date = declaration_date;
    }

    getbdmName(): string {
        return this.bdmName;
    }
    setbdmName(bdmName: string) {
        this.bdmName = bdmName;
    }

    getIs_completed(): boolean {
        return this.is_completed;
    }

    setIs_completed(is_completed: boolean) {
        this.is_completed = is_completed;
    }

    getChecklist() {
        return this.checklist;
    }

    setChecklists(data: Checklist[]) {
        this.checklist = data;
    }

    getRemarkId(): number {
        return this.remarkid;
    }
    setRemarkId(remarkid: number) {
        this.remarkid = remarkid;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }
    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getupdatedbyroleRemark(): string {
        return this.updatedbyroleRemark;
    }
    setupdatedbyroleRemark(updatedbyroleRemark: string) {
        this.updatedbyroleRemark = updatedbyroleRemark;
    }



    toString() {
        return JSON.stringify({
            onboarding_id: this.getOnboardingid(),
            checklist: this.getChecklist(),
            remarks:this.getRemarkContent(),
            remark_id:this.getRemarkId(),
            updated_by_role_remark:this.getupdatedbyroleRemark(),
            declaration: {
                bdm_name: this.getbdmName(),
                declaration_date: this.getDeclaration_date(),
                is_completed: this.getIs_completed()
            }
        });
    }

}
